<template>
  <div data-component-group="filter-forms" data-component="events-promotions">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      v-model="countries"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Dates"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="promotionsStatuses"
        prepend-inner-icon="download_done"
        return-object
        item-title="name"
        label="Status"
      />
    </FiltersForm>
  </div>
</template>

<script>
import FiltersForm from '../FiltersBase';
import { debounce } from '@/utils';
import { v1 as uuidv1 } from 'uuid';
import { mapGetters } from 'vuex';
import filterUrlSync from '@/mixins/filterUrlSync';
import filterChips, { platformChips } from '@/mixins/filterChips';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

export default {
  mixins: [filterUrlSync, filterChips],
  components: {
    FiltersForm,
  },
  data() {
    return {
      urlConfig: [
        { field: 'search', urlKey: 'search', type: 'string' },
        { field: 'countries', urlKey: 'countries', type: 'string[]' },
        { field: 'dates', urlKey: 'dates', type: 'string' },
        // The select is return-object, so the URL carries the id and the stub is
        // swapped for the full status once the store listing is in.
        {
          field: 'status', urlKey: 'status', type: 'number', prop: 'id',
          fetchMethod: 'getPromotionsStatuses', itemsField: 'promotionsStatuses',
        },
      ],
      search: null,
      dates: null,
      countries: [],
      dateConfig: {
        mode: 'range',
      },
      status: null,
    };
  },
  computed: {
    ...mapGetters('events', ['promotionsStatuses']),
    hasFilters() {
      const { search, countries, dates, status } = this;
      return search !== null || countries.length > 0 || !!dates || status !== null;
    },
    filterChipFields() {
      const platforms = this.$store.getters['users/countries'] || [];

      return [
        {
          model: 'countries',
          label: this.$t('platform'),
          toChips: platformChips(platforms),
        },
        { model: 'search', label: 'Search' },
        { model: 'dates', label: 'Dates' },
        { model: 'status', label: 'Status' },
      ];
    },
  },
  emits: ['filter', 'clearFilters'],
  methods: {
    onFilter() {
      const { search, countries, dates, status } = this;

      this.syncFiltersToUrl();
      this.rememberAppliedFilters();

      this.$emit('filter', {
        search,
        countries,
        dates: dates || null,
        status: status ? status.id : null,
      });
    },
    onClearFilters() {
      this.search = null;
      this.countries = [];
      this.dates = null;
      this.status = null;

      this.clearFiltersUrl();
      this.forgetAppliedFilters();

      this.$emit('clearFilters');
    },
    onChangeDate(dates) {
      this.dates = dates;
    },
    getPromotionsStatuses() {
      return this.$store.dispatch('events/getPromotionsStatuses');
    },
  },
};
</script>